export default {
  "IIcon": "_IIcon_5jkr5_1"
};import "ni:sha-256;tcUpgmMOZ0gnykdDzVDR3Ucu1qQKsqSjw2gcmwPeP7c";